import React from 'react';
import { Header, Grid } from 'semantic-ui-react';
import axios from 'axios';
//import { fadeIn, zoomIn } from 'react-animations';
//import { keyframes } from 'styled-components';
//import styled from 'styled-components';
import Notifications from '../Notifications/Notifications';
import StudentUpcomingExams from '../StudentCoursesOverview/StudentUpcomingExams';
import {Route} from "react-router-dom";
import Employees from "../StudentService/Employees/Employees";
import {FormattedMessage} from "react-intl";

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;


export default class StudentHome extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        //const FadeIn = styled.div`animation: 1s ${keyframes`${zoomIn}`}`;
        return (
            <div >
                <Header as="h1"><FormattedMessage id="sidebar.home"/></Header>
                <Grid centered stackable>
                    {/*<Grid.Row>*/}
                    {/*    <Grid.Column width={16} stretched >*/}
                    {/*        <FadeIn> <Notifications /></FadeIn>*/}
                    {/*    </Grid.Column>*/}
                    {/*</Grid.Row>*/}
                    <Grid.Row>
                        <Grid.Column width={16} stretched >
                             <StudentUpcomingExams />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Home/StudentHome.js